/**
 * Baptist Cancer Center Event Search
 *
 * Replaces the previous Angular EventSearchController.
 *
 * Initial events, categories, and venues are rendered server-side.
 * Subsequent filtering and pagination asynchronously request the
 * server-rendered Razor partial.
 */
(function ($) {
    'use strict';

    var SEARCH_ENDPOINT = '/api/sitecore/BccEvents/SearchResults';

    $(document).ready(function () {
        $('[data-event-search-component]').each(function () {
            initializeEventSearch($(this));
        });
    });

    function initializeEventSearch($component) {

        var $loading =
            $component.find('[data-event-loading]');

        /**
         * Return the current browser query string.
         */
        function getSearchParams() {
            return new URLSearchParams(
                window.location.search
            );
        }

        /**
         * Update the browser URL without reloading.
         *
         * Also keep the Secondary Hero search form synchronized with
         * the current asynchronous search state.
         */
        function updateBrowserUrl(searchParams) {

            var queryString =
                searchParams.toString();

            var newUrl =
                window.location.pathname +
                (queryString ? '?' + queryString : '') +
                window.location.hash;

            window.history.pushState(
                { path: newUrl },
                '',
                newUrl
            );

            $('form.bcc-search-form').each(function () {

                var $form = $(this);

                /*
                 * Remove search-state fields previously generated
                 * by JavaScript.
                 */
                $form
                    .find(
                        'input[type="hidden"][data-location-search-param]'
                    )
                    .remove();

                /*
                 * Add the current state back to the Secondary Hero form.
                 *
                 * q is excluded because the hero already owns the
                 * visible search field named q.
                 */
                searchParams.forEach(function (value, key) {

                    if (key === 'q') {
                        return;
                    }

                    $('<input>', {
                        type: 'hidden',
                        name: key,
                        value: value,
                        'data-location-search-param': ''
                    }).appendTo($form);

                });

            });
        }

        /**
         * Toggle the loading indicator.
         */
        function setLoading(isLoading) {

            if (!$loading.length) {
                return;
            }

            if (isLoading) {
                $loading.show();
            }
            else {
                $loading.hide();
            }
        }

        /**
         * Retrieve a new server-rendered event results partial.
         */
        function getResults(resetPage) {

            var searchParams =
                getSearchParams();

            if (resetPage) {
                searchParams.set(
                    'pg',
                    '1'
                );
            }

            updateBrowserUrl(
                searchParams
            );

            setLoading(true);

            $.ajax({
                url: SEARCH_ENDPOINT,
                method: 'GET',
                data: searchParams.toString(),
                cache: false
            })
                .done(function (html) {

                    var $currentResults =
                        $component.find(
                            '[data-event-results-container]'
                        );

                    $currentResults.replaceWith(
                        html
                    );

                })
                .fail(function () {

                    alert(
                        'Error getting events.'
                    );

                })
                .always(function () {

                    setLoading(false);

                });
        }

        /**
         * Select a Category.
         */
        $component.on(
            'click',
            '[data-event-category]',
            function (e) {

                e.preventDefault();

                var categoryId =
                    $(this).attr(
                        'data-event-category'
                    );

                var categoryName =
                    $(this).attr(
                        'data-event-category-name'
                    );

                var searchParams =
                    getSearchParams();

                searchParams.set(
                    'c',
                    categoryId
                );

                searchParams.set(
                    'pg',
                    '1'
                );

                /*
                 * Update the visible dropdown label.
                 */
                $component
                    .find('[data-event-category-label]')
                    .text(categoryName);

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Clear Category.
         */
        $component.on(
            'click',
            '[data-event-clear-category]',
            function (e) {

                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete(
                    'c'
                );

                searchParams.set(
                    'pg',
                    '1'
                );

                $component
                    .find('[data-event-category-label]')
                    .text('Select');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Select a Venue / Location.
         */
        $component.on(
            'click',
            '[data-event-venue]',
            function (e) {

                e.preventDefault();

                var venueId =
                    $(this).attr(
                        'data-event-venue'
                    );

                var venueName =
                    $(this).attr(
                        'data-event-venue-name'
                    );

                var searchParams =
                    getSearchParams();

                searchParams.set(
                    'v',
                    venueId
                );

                searchParams.set(
                    'pg',
                    '1'
                );

                /*
                 * Update the visible dropdown label.
                 */
                $component
                    .find('[data-event-venue-label]')
                    .text(venueName);

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Clear Venue / Location.
         */
        $component.on(
            'click',
            '[data-event-clear-venue]',
            function (e) {

                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete(
                    'v'
                );

                searchParams.set(
                    'pg',
                    '1'
                );

                $component
                    .find('[data-event-venue-label]')
                    .text('Select');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Clear all filters.
         *
         * The old markup had a Clear All Selections button but did not
         * actually attach an ng-click handler to it. This gives that
         * existing UI control its intended behavior.
         */
        $component.on(
            'click',
            '[data-event-clear-all]',
            function (e) {

                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete(
                    'c'
                );

                searchParams.delete(
                    'v'
                );

                searchParams.set(
                    'pg',
                    '1'
                );

                $component
                    .find('[data-event-category-label]')
                    .text('Select');

                $component
                    .find('[data-event-venue-label]')
                    .text('Select');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /**
         * Pagination.
         *
         * Delegated because the pagination HTML is replaced after every
         * asynchronous request.
         */
        $component.on(
            'click',
            '[data-event-page]',
            function (e) {

                e.preventDefault();

                var page =
                    parseInt(
                        $(this).attr(
                            'data-event-page'
                        ),
                        10
                    );

                if (!page ||
                    page < 1) {

                    return;
                }

                var searchParams =
                    getSearchParams();

                searchParams.set(
                    'pg',
                    page
                );

                updateBrowserUrl(
                    searchParams
                );

                /*
                 * Scroll back to the top of the event search component
                 * when changing pages.
                 */
                if ($component.length) {

                    $(
                        [
                            document.documentElement,
                            document.body
                        ]
                    ).animate(
                        {
                            scrollTop:
                                $component
                                    .offset()
                                    .top
                        },
                        400
                    );
                }

                getResults(false);
            }
        );

        /**
         * Browser Back / Forward.
         *
         * Reload the page so the complete SSR state, including the
         * category and venue labels, matches the restored URL.
         */
        $(window).on(
            'popstate.eventSearch-' +
            $component.attr('id'),
            function () {

                window.location.reload();

            }
        );
    }

})(jQuery);